import { IAumMenuOptions, IAumMenuOptionsForRow } from '../../pattern/menu';
import { IColumn } from './IColumn.interface';
import { IElementAction } from './IElementAction.interface';

export interface ITableOptions {
    columns: IColumn[];
    rowClickAction?: IElementAction;
    menu?: IAumMenuOptions;
    menuPerRow?: IAumMenuOptionsForRow;
    singleSelectionProperty?: string;
}
